export const Images = {
  logo: "/logo.svg",
  logoDark: "/logo-dark.svg",
  logoOnLight: "/logo-on-light.svg",
  faviconMark: "/favicon-mark.png",

  g2Medal: "/recognition/g2-medal.svg",
  g2MedalRoot: "/g2-medal.svg",
  g2UsersLoveUs: "/recognition/g2-users-love-us.svg",
  g2UsersLoveUsRoot: "/g2-users-love-us.svg",
  iso27001: "/recognition/iso27001.png",
  soc2: "/recognition/soc2.png",

  g2Dark: "/reviews/main/g2-dark-0.svg",
  g2Light: "/reviews/main/g2-light-0.svg",
  trustpilotDark: "/reviews/trustpilot-dark.svg",
  trustpilotOnLight: "/reviews/trustpilot-on-light.svg",
  reviewsMain: {
    g2Main: "/reviews/main/g2_main.svg",
    g2ShortDark: "/reviews/main/g2_short_dark.svg",
    g2Card: "/reviews/main/g2.svg",
    g2CardOnLight: "/reviews/main/g2-on-light.svg",
    tpMain: "/reviews/main/tp_main.svg",
    tpShortDark: "/reviews/main/tp_short_dark.svg",
  },

  blogHeroWave: "/blog-hero-wave.png",
  proxidizeAndroidQr: "/proxidize-android-qr.png",

  team: {
    abedElezz: "/team/abed-elezz.png",
    basharJazaeri: "/team/bashar-jazaeri.png",
    danielCantillo: "/team/daniel-cantillo.webp",
    eyadElkhatib: "/team/eyad-elkhatib.png",
    fawazAlghzawi: "/team/fawaz-al-ghzawi.png",
    josh: "/team/josh.png",
    omarHussein: "/team/omar-hussein.png",
    osamaIbrahim: "/team/osama-ibrahim.png",
    yazanSharawi: "/team/yazan-sharawi.png",
    mahmoudAbabneh: "/team/mahmoud-ababneh.png",
    mayaAbuelezz: "/team/maya-abuelezz.png",
    muhannadAbdulla: "/team/muhannad-abdulla.png",
    yamenAlazzam: "/team/yamen-alazzam.png",
    yazidKurdi: "/team/yazid-kurdi.png",
    zeidAbughazaleh: "/team/zeid-abughazaleh.png",
  },
};
